import { defineStore } from 'pinia';
import { otpService } from '../services/otp-service';

export const useOtpStore = defineStore('otp-store', {
    state: () => ({
        channel:          'sms',
        code:             '',
        processing:       false,
        error:            '',
        validationErrors: null,
    }),

    actions: {
        async send(identifier, channel) {
            this.channel = channel;
            this.code    = '';
            this.error   = '';
            try {
                await otpService.send(identifier, channel);
            } catch (e) {
                this.error = e.response?.data?.message || 'Could not send code. Please try again.';
            }
        },

        async switchChannel(identifier, channel) {
            this.channel = channel;
            this.code    = '';
            this.error   = '';
            try {
                await otpService.send(identifier, channel);
            } catch (e) {
                this.error = e.response?.data?.message || 'Could not send code. Please try again.';
            }
        },

        async resend(identifier) {
            this.error = '';
            try {
                await otpService.send(identifier, this.channel);
            } catch (e) {
                this.error = e.response?.data?.message || 'Could not send code. Please try again.';
            }
        },

        async verify(identifier) {
            this.error            = '';
            this.validationErrors = null;
            this.processing       = true;
            try {
                await otpService.verify(identifier, this.code);
                return { done: true };
            } catch (e) {
                if (e.response?.status === 422) {
                    this.validationErrors = e.response.data?.errors || null;
                } else {
                    this.error = e.response?.data?.message || 'Something went wrong. Please try again.';
                }
                return null;
            } finally {
                this.processing = false;
            }
        },

        reset() {
            this.$reset();
        },
    },
});